import React, { useEffect, useState } from 'react';
import Flickity from 'react-flickity-component';
import CariHarga from './../assets/images/cari_harga.png';
import CekHarga from './../assets/images/cek_harga.png';
import KreasikanData from './../assets/images/kreasikan_data.png';
import './../css/overview.scss';
import Line from '../components/Line';
import Info1 from './../assets/images/info1.png';
import Info2 from './../assets/images/info2.png';
import Info3 from './../assets/images/info3.png';
import { FilterOverview } from './FilterOverview';
import { useHistory, useLocation } from 'react-router-dom';
import Sidebar from './../components/Sidebar';
import BottomNav from '../components/BottomNav';
import TopNav from '../components/TopNav';
import Logo from './../assets/images/logo_overview.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons';
import FilterOverviewMobile from './FilterOverviewMobile';
import Popular from '../components/Popular';
import PopularMobile from '../components/PopularMobile';
import amplitude from 'amplitude-js';
import { viewAcvWebsite, viewCekHarga } from '../services/amplitude';
import { howToAuction } from '../constant/howToAuction';
import CarouselCard from '../components/CarouselCard';
import '../css/slider.scss';

const Overview = () => {
  let history = useHistory();
  const location = useLocation();
  const pageChannel = location.state && location.state.pageChannel;

  const [onSearchMobile, setOnSearchMobile] = useState(false);

  useEffect(() => {
    amplitude.getInstance().logEvent('Visit Web Homepage', {
      page_channel: pageChannel,
    });
  }, []);

  function toPage(route) {
    history.push(route);
  }

  return (
    <>
      <div className="page-overview overview-page">
        <TopNav pageChannel="Overview" />
        <div className="container-fluid main-overview">
          <div className="row">
            <Sidebar pageChannel="Overview" />
            <BottomNav history={history} />
            <div className="col-xl-10 col-lg-12 pt-3 content">
              <div className="container-fluid card shadow-sm">
                <div className="row">
                  <div className="col-md-12 py-5">
                    <div className="row d-lg-flex align-items-lg-center align-items-md-start">
                      <div className="col-lg-4 col-md-6 col-sm-12">
                        <img src={CariHarga} alt="cari-harga" className="img-fluid" />
                      </div>
                      <div className="col-sm-12 d-lg-none d-md-none d-sm-block text-center">
                        <p className="overview-title mb-2">Butuh Informasi Harga Kendaraan Lelang?</p>
                        <p className="overview-subtitle">Cari Harga Kendaraan Lelang di Sini</p>
                        <button className="btn-overview-green mt-1">Cari Harga</button>
                      </div>
                      <FilterOverview />
                    </div>
                  </div>
                </div>
              </div>
              <Popular />
              <div className="container-fluid mt-3 shadow-sm">
                <div className="row">
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-0 pr-2 mb-md-0 mb-sm-3">
                    <div className="card float-right">
                      <div className="row d-flex align-items-center p-md-4">
                        <div className="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center py-5">
                          <img src={CekHarga} alt="cek-harga" className="img-fluid" />
                        </div>
                        <div className="col-lg-8 col-md-6 col-sm-12 pr-5 text-md-left text-sm-center py-1">
                          <p className="overview-title mb-1">Berencana Menjual Kendaraan Anda ?</p>
                          <p className="overview-subtitle">Cek Harga Kendraan di Sini</p>
                          <p className="overview-paragraph">
                            Cari tahu simulasi harga lelang kendaraan anda dari waktu ke waktu
                          </p>
                          <button
                            onClick={() => {
                              history.push({
                                pathname: '/cek-harga-kendaraan',
                                pageChannel: 'Overview',
                              });
                              viewCekHarga();
                            }}
                            className="btn-overview-green mb-md-0 mb-sm-2"
                          >
                            Cek Harga Kendaraan
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-6 col-lg-6 col-md-6 col-sm-12 p-0 pl-2 mb-md-0 mb-sm-3">
                    <div className="card">
                      <div className="row d-flex align-items-center p-md-4">
                        <div className="col-lg-4 col-md-6 col-sm-12 d-flex justify-content-center py-5">
                          <img src={KreasikanData} alt="cek-harga" className="img-fluid" />
                        </div>
                        <div className="col-lg-8 col-md-6 col-sm-12 pr-5 text-md-left text-sm-center py-1">
                          <p className="overview-title mb-1">Personalisasi Tampilan Grafik</p>
                          <p className="overview-subtitle">Kreasikan Data Anda di Sini</p>
                          <p className="overview-paragraph">
                            Kreasikan data dengan berbagai opsi tampilan grafik sesuai keinginan Anda.
                          </p>
                          <button className="btn-overview-green mb-md-0 mb-sm-2" onClick={() => toPage('/insights')}>
                            Personalisasi Grafik
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="container-fluid mt-3 card shadow">
                <div className="row d-flex align-items-center">
                  <div className="col-lg-3 col-md-6 col-sm-12 d-flex justify-content-center py-5">
                    <img src={CekHarga} alt="cek-harga" className="img-fluid" />
                  </div>
                  <div className="col-lg-8 col-md-6  col-sm-12 pr-5 text-md-left text-sm-center py-1">
                    <p className="overview-title mb-1">Cek Kondisi Kendaraan Anda</p>
                    <p className="overview-subtitle">Astra Car Valuation (ACV)</p>
                    <p className="overview-paragraph">
                      Astra Car Valuation menyediakan solusi inspeksi mobil yang lengkap dengan layanan terpercaya dari
                      para ahli yang telah berpengalaman. Kami akan memberikan laporan hasil inspeksi yang akurat,
                      transparan, dan detail sehingga Anda mendapatkan informasi menyeluruh tentang kondisi mobil.
                    </p>
                    <a
                      href="https://acv.astra.co.id/"
                      target="_blank"
                      className="btn-overview-green mb-md-0 mb-sm-2"
                      onClick={() => viewAcvWebsite()}
                    >
                      Lihat Selengkapnya
                    </a>
                  </div>
                </div>
              </div>
              <div className="container-fluid mt-3 card overview-lelang mb-5">
                <div className="row d-flex align-items-center py-3">
                  <div className="col-lg-5 col-md-6 pt-2">
                    <iframe
                      className="iframe-video"
                      src="https://www.youtube.com/embed/j8No0xpi05o"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    ></iframe>
                  </div>
                  <div className="col-lg-7 col-md-6">
                    <p className="overview-title mb-1">Personalisasi Tampilan Grafik</p>
                    <p className="overview-subtitle">Kreasikan Data Anda di Sini</p>
                    <p className="overview-paragraph">
                      IBID-Balai Lelang Serasi (IBID) adalah merupakan balai lelang yang melelang produk otomotif, gaya
                      hidup, serta kebutuhan industri seperti alat berat dan scrap. Selain membeli produk otomotif, Anda
                      pun dapat menitip jualkan kendaraan di IBID baik untuk perusahaan maupun perorangan. IBID memiliki
                      10 cabang resmi di Indonesia yaitu Jakarta, Bandung, Semarang, Surabaya, Medan, Pekanbaru,
                      Palembang, Banjarmasin, Balikpapan, dan Makassar.
                    </p>
                    <button
                      onClick={() =>
                        history.push({
                          pathname: '/insights',
                          pageChannel: 'Overview',
                        })
                      }
                      className="btn-overview-green"
                    >
                      Custom Chart
                    </button>
                  </div>
                </div>
                <Line height={2} width="100%" color="#E6E4E4" />
                <div className="row d-flex py-3">
                  <div className="col-lg-5 col-md-4 col-sm-12 pt-2">
                    <p className="overview-subtitle">Cara Ikut Lelang di IBID</p>
                    <p className="overview-paragraph">
                      IBID balai lelang serasi menyediakan opsi metode lelang dengan berbagai keunggulan masing-masing
                      Onsite Auction, Live Auction, dan Online Auction untuk mendukung kebutuhan anda.
                    </p>
                    <iframe
                      className="iframe-video"
                      src="https://www.youtube.com/embed/I_AzrlDpZjY"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    ></iframe>
                  </div>
                  <div className="col-lg-7 col-md-8 col-sm-12 overview-lelang-carousel position-relative p-2">
                    <Flickity
                      elementType={'div'}
                      options={{
                        contain: true,
                        pageDots: false,
                        adaptiveHeight: true,
                      }}
                      reloadOnUpdate
                    >
                      {howToAuction.map((item, index) => (
                        <CarouselCard
                          key={index}
                          newBadge={item.newBadge}
                          title={item.title}
                          description={item.description}
                          imageUrl={item.imgUrl}
                          urlLink={item.urlLink}
                        />
                      ))}
                    </Flickity>
                  </div>
                </div>
                <Line height={2} width="100%" color="#E6E4E4" />
                <div className="row d-flex align-items-end py-3">
                  <div className="col-md-5 pt-2">
                    <p className="overview-subtitle">Cara Titip Lelang di IBID</p>
                    <p className="overview-paragraph">
                      Anda bisa menjual kendaraan bekas dengan mengikuti titip lelang IBID. Proses cepat, mudah, aman,
                      dan terpecaya. Ketahui caranya di sini.
                    </p>
                    <iframe
                      className="iframe-video"
                      src="https://www.youtube.com/embed/a66n9t1w3qs"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    ></iframe>
                  </div>
                  <div className="col-md-7 overview-lelang-card">
                    <div className="container-fluid">
                      <div className="row">
                        <div className="col-lg-12 pb-2">
                          <div className="stepper-wrapper text-white">
                            <div className="stepper-item completed">
                              <div className="step-counter">1</div>
                            </div>
                            <div className="stepper-item completed">
                              <div className="step-counter">2</div>
                            </div>
                            <div className="stepper-item active">
                              <div className="step-counter">3</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="row">
                        <div className="col-lg-4 col-md-4 col-sm-4 px-1 overview-lelang-card-item">
                          <div className="overview-auction-card">
                            <div className="p-3">
                              <img className="card-img-top" src={Info1} alt="Card image cap" />
                            </div>
                            <div className="card-body">
                              <h5 className="card-title overview-subtitle">
                                Isi formulir titip lelang di website IBID
                              </h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 px-1 overview-lelang-card-item">
                          <div className="overview-auction-card">
                            <div className="p-3">
                              <img className="card-img-top" src={Info2} alt="Card cap" />
                            </div>
                            <div className="card-body">
                              <h5 className="card-title overview-subtitle">Pilih jadwal inspeksi kendaraan</h5>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-4 col-sm-4 px-1 overview-lelang-card-item">
                          <div className="overview-auction-card">
                            <div className="p-3">
                              <img className="card-img-top" src={Info3} alt="Card cap" />
                            </div>
                            <div className="card-body">
                              <h5 className="card-title overview-subtitle">
                                Datang ke poll IBID untuk proses inspeksi
                              </h5>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {!onSearchMobile ? (
        <div className="page-overview-mobile mb-3" style={{ backgroundColor: '#f0f0f0' }}>
          <BottomNav history={history} />
          <div className="container-fluid">
            <div className="row bg-light">
              <div className="col-12 pt-3 pb-2 d-flex px-4 align-items-center header">
                <img src={Logo} style={{ width: '20%', height: '90%' }} alt='Market Auction Price' />
                <h4 className="ml-4 text-secondary" style={{ fontSize: '6vw' }}>
                  <b>Market Auction Price</b>
                </h4>
              </div>
            </div>
            <div className="row bg-light mt-2">
              <div className="col-12 d-flex flex-column align-items-center pb-4">
                <img src={CariHarga} style={{ width: '90%', height: '90%' }} alt='Butuh Informasi Harga Kendaraan Lelang?' />
                <label>Butuh Informasi Harga Kendaraan Lelang?</label>
                <h5>Cari Harga Kendaraan Lelang Disini</h5>
                <button
                  className="btn-overview-green-solid w-100 mt-2 py-2"
                  onClick={() => {
                    setOnSearchMobile(true);
                  }}
                  style={{ fontSize: 18 }}
                >
                  Cari Harga Kendaraan
                </button>
              </div>
            </div>
            <div className="row mt-2 bg-light">
              <PopularMobile />
            </div>
            <div className="row mt-2 bg-light">
              <div className="col-12 d-flex flex-column align-items-center text-center pb-4">
                <img src={CekHarga} style={{ width: '90%', height: '90%' }} alt='Berencana Menjual Kendaraanmu?' />
                <label>Berencana Menjual Kendaraanmu?</label>
                <h5>Cek Harga Kendaraan Disini</h5>
                <label>Cari tahu berapa harga kendaraan anda &amp; ikuti simulasi harga lelang yang kami miliki</label>
                <button
                  onClick={() => {
                    history.push('/cek-harga-kendaraan');
                    viewCekHarga();
                  }}
                  className="btn-overview-green w-100 mt-2 py-2"
                  style={{ fontSize: 18 }}
                >
                  Cek Harga Kendaraan
                </button>
              </div>
            </div>
            <div className="row mt-2 bg-light">
              <div className="col-12 d-flex flex-column align-items-center text-center pb-4">
                <img src={KreasikanData} style={{ width: '90%', height: '90%' }} alt='Custom Tampilan Chart Sepuasnya' />
                <label>Custom Tampilan Chart Sepuasnya</label>
                <h5>Kreasikan Datamu Disini</h5>
                <label>Kreasikan data yang kamu inginkan dengan banyak tampilan chart</label>

                <button
                  className="btn-overview-green w-100 mt-2 py-2"
                  style={{ fontSize: 18 }}
                  onClick={() => toPage('/insights')}
                >
                  Personalisasi Grafik
                </button>
              </div>
            </div>
            <div className="row mt-2 bg-light">
              <div className="col-12 d-flex flex-column align-items-center text-center pb-4">
                <img src={CekHarga} style={{ width: '90%', height: '90%' }} alt='check condition vehicle' />
                <label>Cek Kondisi Kendaraan Anda</label>
                <h5>Astra Car Valuation (ACV)</h5>
                <label>
                  Astra Car Valuation menyediakan solusi inspeksi mobil yang lengkap dengan layanan terpercaya dari para
                  ahli yang telah berpengalaman. Kami akan memberikan laporan hasil inspeksi yang akurat, transparan,
                  dan detail, sehingga Anda mendapatkan informasi menyeluruh tentang kondisi mobil
                </label>
                <button
                  className="btn-overview-green w-100 mt-2 py-2"
                  style={{ fontSize: 18 }}
                  onClick={() => {
                    window.open('https://acv.astra.co.id/', '_blank', 'noopener,noreferrer');
                    viewAcvWebsite();
                  }}
                >
                  Lihat Selengkapnya
                </button>
              </div>
            </div>
            <div className="row mt-2 bg-light">
              <div className="col-12 d-flex flex-column align-items-center text-center pb-4 pt-2">
                <div className="embed-responsive embed-responsive-16by9 border rounded">
                  <iframe
                    className="iframe-video"
                    src="https://www.youtube.com/embed/j8No0xpi05o"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    style={{ width: '100%', height: '100%' }}
                  ></iframe>
                </div>
                <label className="mt-2">Kenal Lebih Dekat</label>
                <h5>Balai Lelang Serasi (IBID)</h5>
                <label>
                  IBID-Balai Lelang Serasi (IBID) adalah balai lelang yang melelang produk-produk otomotif seperti
                  kendaraan roda dua dan roda empat, namun saat ini kami juga telah melelang barang-barang non-otomotif
                  seperti gadget dan alat berat. Anda tidak hanya dapat berpartisipasi di lelang untuk membeli kedaraan,
                  namun IBID juga bisa menjadi solusi penjualan untuk mitra perusahaan yang ingin menjual aset kendaraan
                  mereka. Tidak hanya untuk perusahaan, sebagai perorangan Anda juga dapat menitipkan kendaraan untuk
                  dijual melalui lelang IBID.
                </label>
                <button className="btn-overview-green w-100 mt-2 py-2 mb-4" style={{ fontSize: 18 }}>
                  Lihat Selengkapnya
                </button>
                <Line height={3} width="100%" color="#E6E4E4" />
                <h5 className="mt-4">Cara Ikut Lelang di IBID</h5>
                <label>
                  IBID balai lelang serasi menyediakan opsi metode lelang dengan berbagai keunggulan masing-masing.
                  Onsite Auction, Live Auction, dan Online Auction untuk mendukung kebutuhan anda
                </label>
                <div className="embed-responsive embed-responsive-16by9  border rounded">
                  <iframe
                    className="iframe-video"
                    src="https://www.youtube.com/embed/I_AzrlDpZjY"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  ></iframe>
                </div>
                <div
                  className="mt-3 px-3 py-2 mb-2"
                  style={{
                    overflowX: 'scroll',
                    width: '100vw',
                    display: 'flex',
                    flexDirection: 'row',
                  }}
                >
                  {howToAuction.map((item, index) => (
                    <div
                      key={index}
                      className="px-4 py-3 mr-3"
                      style={{
                        border: '2px solid #d6d7d8',
                        borderRadius: 4,
                        width: 450,
                        fontSize: 16,
                        textAlign: 'start',
                        flexBasis: 240,
                        flexGrow: 0,
                        flexShrink: 0,
                        position: 'relative',
                      }}
                    >
                      <img src={item.imgUrl} width={150} height={100} alt='title overview' />
                      <h5 className="my-2">{item.title}</h5>
                      <label>{item.description}</label>
                      <div className="text-center" style={{}}>
                        <a href="#">Lihat Selengkapnya &#8594;</a>
                      </div>
                    </div>
                  ))}
                </div>
                <Line height={3} width="100%" color="#E6E4E4" />
                <h5 className="text-secondary mt-3">Cara Titip Lelang di IBID</h5>
                <label className="text-secondary my-3">
                  Ibiders mau jual mobil lamamu? bisa titip lelang di IBID. Ada ratusan calon pembeli yang akan menawar
                  mobil ibiders. Proses cepat, mudah, aman, dan terpercaya. Ketahui caranya disini.
                </label>
                <div className="embed-responsive embed-responsive-16by9 border rounded">
                  <iframe
                    className="iframe-video"
                    src="https://www.youtube.com/embed/I_AzrlDpZjY"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  ></iframe>
                </div>
                <div>
                  <div className="mt-3 px-3 py-3 mb-5" style={{ overflowX: 'scroll', width: '100vw' }}>
                    <div className="stepper-wrapper" style={{ color: '#82be2a', fontWeight: 700 }}>
                      <div className="stepper-item completed">
                        <div className="step-counter">1</div>
                      </div>
                      <div className="stepper-item completed">
                        <div className="step-counter">2</div>
                      </div>
                      <div className="stepper-item completed">
                        <div className="step-counter">3</div>
                      </div>
                    </div>
                    <div style={{ display: 'flex', flexDirection: 'row' }}>
                      <div
                        className="px-4 py-3 mr-3"
                        style={{
                          border: '2px solid #d6d7d8',
                          borderRadius: 4,
                          width: 450,
                          fontSize: 16,
                          textAlign: 'start',
                          flexBasis: 240,
                          flexGrow: 0,
                          flexShrink: 0,
                          position: 'relative',
                        }}
                      >
                        <img src={Info1} alt='Isi formulir titip lelang di website ibid' />
                        <h5 className="my-2">Isi formulir titip lelang di website ibid</h5>
                      </div>
                      <div
                        className="px-4 py-3 mr-3"
                        style={{
                          border: '2px solid #d6d7d8',
                          borderRadius: 4,
                          width: 450,
                          fontSize: 16,
                          textAlign: 'start',
                          flexBasis: 240,
                          flexGrow: 0,
                          flexShrink: 0,
                          position: 'relative',
                        }}
                      >
                        <img src={Info2} alt='Pilih jadwal inspeksi kendaraan' />
                        <h5 className="my-2">Pilih jadwal inspeksi kendaraan</h5>
                      </div>
                      <div
                        className="px-4 py-3 mr-3"
                        style={{
                          border: '2px solid #d6d7d8',
                          borderRadius: 4,
                          width: 450,
                          fontSize: 16,
                          textAlign: 'start',
                          flexBasis: 240,
                          flexGrow: 0,
                          flexShrink: 0,
                          position: 'relative',
                        }}
                      >
                        <img src={Info3} alt='Datang ke poll IBID untuk proses inspeksi' />
                        <h5 className="my-2">Datang ke poll IBID untuk proses inspeksi</h5>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      ) : (
        <div className="page-overview-mobile">
          <div className="container-fluid">
            <div className="row">
              <div
                className="col-12 pt-3 pb-2 d-flex px-4 align-items-center header"
                style={{ boxShadow: '0px 0px 0px 4px rgba(232,232,232, 0.7)' }}
              >
                <FontAwesomeIcon
                  className="mb-2"
                  onClick={() => {
                    setOnSearchMobile(false);
                  }}
                  icon={faArrowLeft}
                />
                <h4 className="ml-5" style={{ fontSize: '6vw' }}>
                  Cari Harga Kendaraan
                </h4>
              </div>
            </div>
            <div className="row mt-3">
              <div className="col-12 text-center">
                <label>Butuh Informasi Harga Kendaraan Lelang?</label>
                <h5>Cari Harga Kendaraan Lelang Disini</h5>
              </div>
            </div>
            <div className="row mt-3">
              <FilterOverviewMobile />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Overview;
